export const GET_ACTIVITY_DATA = 'GET_ACTIVITY_DATA';
export const GET_ACTIVITY_DATA_SUCCESS = 'GET_ACTIVITY_DATA_SUCCESS';
export const GET_ACTIVITY_DATA_ERROR = 'GET_ACTIVITY_DATA_ERROR';
export const START_ACTIVITY = 'START_ACTIVITY';
export const RESET_ACTIVITY_STORE = 'RESET_ACTIVITY_STORE';
